import React from 'react';
import SalesGraph from './SalesGraph';
import LatestOrders from './LatestOrders';
import OrderStatusBreakdown from './OrderStatusBreakdown';
import QuickActions from './QuickActions';
import PendingReviews from './PendingReviews';
import TopProducts from './TopProducts';
import OutOfStock from './OutOfStock';

const AdminDash = () => {
  return (
    <div className="admin-dash">
      <div className="admin-dash-grid">
        <div className="admin-dash-graph">
          <SalesGraph />
        </div>
        <div className="admin-dash-orders">
          <LatestOrders />
        </div>
      </div>

      <div className="admin-dash-grid admin-dash-grid-3">
        <OrderStatusBreakdown />
        <QuickActions />
        <PendingReviews />
      </div>

      <div className="admin-dash-grid">
        <TopProducts />
        <OutOfStock />
      </div>

    </div>
  );
};

export default AdminDash;
